<template>
  <div id="guest-info">
    <div class="container-guest">
      <div class="adult choice-number row">
        <div class="col-4">
          <p class="raleway-reg-p15 mb-0">Adultes</p>
        </div>
        <div class="col-3 decrease-adults" @click="decreaseAdults()">
          <img src="../../images/Moins.svg" v-set-alt />
        </div>
        <div class="col-2">
          <p class="raleway-bold-p mb-0 adults-count">{{ adults }}</p>
        </div>
        <div class="col-2 increase-adults" @click="increaseAdults()">
          <img src="../../images/Plus.svg" v-set-alt />
        </div>
      </div>

      <div class="child choice-number row">
        <div class="col-4">
          <p class="raleway-reg-p15 mb-0">Enfants</p>
        </div>
        <div class="col-3 decrease-children" @click="decreaseChilds()">
          <img src="../../images/Moins.svg" v-set-alt />
        </div>
        <div class="col-2">
          <p class="raleway-bold-p mb-0 children-count">{{ childs }}</p>
        </div>
        <div class="col-2 increase-children" @click="increaseChilds()">
          <img src="../../images/Plus.svg" v-set-alt />
        </div>
      </div>

      <div class="dropdown-age child-age-selector d-flex dropdown-age flex-column" :style="{ gap: '5px' }" v-if="childs">
        <p class="raleway-reg-p15">
          Quel est l’âge {{ formatName(childs) }} voyageant avec vous ?
        </p>
        <template v-for="(child, index) in childs">
          <v-select
            class="select-item"
            placeholder="age"
            v-model="ageSelected[index]"
            :options="agesChoices"
            @input="selectAges(index, $event)"
          ></v-select>
        </template>
      </div>

      <p v-if="showAgeError" class="text-danger mb-0 mt-1 raleway-medi-p12 text-center">
        Merci de nous indiquer l'âge de vos enfants
      </p>

      <div>
        <button class="hortense-btn-primary w-100 mt-2" @click="close()">VALIDER</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GuestInfo",
  props: {
    initialAdults: {
      type: Number,
      default: 2
    },
    initialChilds: {
      type: Number,
      default: 0
    },
    initialChildAges: {
      type: Array,
      default: () => []
    },
    ageErrorTrigger: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      adults: this.initialAdults,
      childs: this.initialChilds,
      ageSelected: [...this.initialChildAges],
      agesChoices: [
        "1 an", "2 ans", "3 ans", "4 ans", "5 ans", "6 ans",
        "7 ans", "8 ans", "9 ans", "10 ans", "11 ans", "12 ans",
        "13 ans", "14 ans", "15 ans", "16 ans", "17 ans"
      ],
      showAgeError: false
    };
  },
  watch: {
    childs(newCount) {
      if (newCount > this.ageSelected.length) {
        this.ageSelected.push(...new Array(newCount - this.ageSelected.length).fill(null));
      } else {
        this.ageSelected = this.ageSelected.slice(0, newCount);
      }
    },
    ageErrorTrigger: {
      immediate: true,
      handler() {
        this.showAgeError = this.hasMissingChildAges();
      }
    }
  },
  methods: {
    close() {
      if (this.hasMissingChildAges()) {
        this.showAgeError = true;
        return;
      }

      this.showAgeError = false;
      this.$emit("updatedGuestState", {
        adults: this.adults,
        childs: this.childs,
        ageSelected: this.ageSelected
      });
      this.$emit("closed");
    },
    selectAges(index, value) {
      this.ageSelected[index] = value;
      this.showAgeError = this.hasMissingChildAges();
      this.$emit("ageSelected", [...this.ageSelected]);
    },
    formatName(count) {
      return count > 1 ? "des enfants" : "de l'enfant";
    },
    hasMissingChildAges() {
      const childCount = Number.parseInt(this.childs, 10) || 0;
      if (childCount <= 0) return false;

      const selectedAges = this.ageSelected.slice(0, childCount);
      return selectedAges.length < childCount || selectedAges.some((age) => !String(age || '').trim());
    },
    decreaseChilds() {
      if (this.childs > 0) {
        this.childs -= 1;
        this.showAgeError = this.hasMissingChildAges();
        this.$emit("decreaseChilds", this.childs);
      }
    },
    increaseChilds() {
      if (this.childs < 30) {
        this.childs += 1;
        this.showAgeError = this.hasMissingChildAges();
        this.$emit("increaseChilds", this.childs);
      }
    },
    decreaseAdults() {
      if (this.adults > 1) {
        this.adults -= 1;
        this.$emit("decreaseAdults", this.adults);
      }
    },
    increaseAdults() {
      if (this.adults < 30) {
        this.adults += 1;
        this.$emit("increaseAdults", this.adults);
      }
    }
  }
};
</script>
<style lang="scss" scope="app/assets/stylesheets/components/search-btn">
</style>
